module.exports = __webpack_public_path__ + "static/media/spin-off.77061a27.png";